export default __webpack_public_path__ + "static/media/Fiona_Ma.eaac8932.jpg";